<template>
  <div class="content" style="position: relative;
  width: 100%;
  height: auto;
  font-size: 12px;">
    <img class="header" style="
    width: 100%;
    height: auto;
    display: block;margin-bottom: -1px;" src="https://static.yunlvltd.com/img/tp-06-14.jpg">
    <div class="body" :style="{
    position: 'relative',
    width: '100%',
    height: 'auto',
    marginBottom: '-1px',
  }">
      <img class="background" style="
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;" src="../../assets/bg-m-0614-mid.jpg">
      <div class="con1" style="
    position: relative;
    width: 77%;
    margin: 0 auto;" :style="{ height: data.length * topPosition + 4 + 'vh' }">
        <div
          class="list"
          v-for="(item, i) in data" :key="item.id"
          :style="{
            top: 1.5 +i * topPosition + 'vh',
            zIndex: i,
            height: topPosition + 'vh'
          }"
          style="
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;"
          >
    <div class="item-inner paiming" style="
    display: flex;
    align-items: center;
    height: 100%;
    color: #fff;
    text-align: center;">
      <div style="
        width: 20px;
        height: 20px;
        border-radius: 50%;
        line-height: 20px;
        font-weight: bold;"
        :style="{
            background: i < taotaiNum ? 'linear-gradient(135deg, rgb(255 115 115 / 90%) 0%, rgb(255 93 93 / 85%) 50%, rgb(255 14 14 / 90%) 100%)' : 'linear-gradient(135deg, rgb(196 196 196 / 80%) 0%, rgb(183 183 183 / 75%) 50%, rgb(145 145 145 / 80%) 100%)',
            boxShadow: i < taotaiNum ? '0 0 10px rgba(255, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 2px 4px rgba(0, 0, 0, 0.2)': 'inset 0 1px 0 rgba(255, 255, 255, 0.4),0 1px 3px rgba(0, 0, 0, 0.2)'
        }">{{i + 1}}
      </div>
      <!-- 
        :style="{
            backgroundImage: `url(${i < taotaiNum ? require('../../assets/xuetiao1.png') : require('../../assets/xuetiao2.png')})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
        }" -->
    </div>
          <div class="item-inner logo" style="
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 1vh 0 1vh;
  width: 5vh;
  aspect-ratio: 1/1;
  position: relative;">
            <!-- <img
            v-if="i < taotaiNum"
            style="
            position: absolute;
            top: -47%;
            left: -16%;
            height: 80%;
            width: auto;
            " class="huangguan" src="../../assets/huangguan.png"> -->
            <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`" style="
    width: 100%;
    height: auto;
    border: 1px solid #fff;
    border-radius: 50%;">
          </div>
          <div
            :class="`item`"
            style="
  position: relative;
  color: #fff;
  width: calc(100% - 65px);
  height: calc(100% - 10px);
  display: flex;
  flex-direction: column;"
          >
            <div class="item-inner nickname"
            style="
  display: flex;
  align-items: flex-end;
  height: 3vh;
  font-size: 14px;
  font-weight: bold;
  font-style: italic;"><span>{{item.nickname }}</span></div>
            <div
              class="item-inner total"
              style="
  display: flex;
  align-items: center;
  height: 3vh;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  line-height: 18px;
  padding-right: 5px;
  box-sizing: border-box;
  position: relative;
  border-radius: 4px;
  overflow: hiiden;"
  :style="{
            background: i < taotaiNum ? 'linear-gradient(135deg, rgb(255 115 115 / 90%) 0%, rgb(255 93 93 / 85%) 50%, rgb(255 14 14 / 90%) 100%)' : 'linear-gradient(135deg, rgb(196 196 196 / 80%) 0%, rgb(183 183 183 / 75%) 50%, rgb(145 145 145 / 80%) 100%)',
            boxShadow: i < taotaiNum ? '0 0 10px rgba(255, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 2px 4px rgba(0, 0, 0, 0.2)': 'inset 0 1px 0 rgba(255, 255, 255, 0.4),0 1px 3px rgba(0, 0, 0, 0.2)'
        }"
            >
            <!-- 
  text-shadow: rgb(255 0 255) -1px -1px 3px, rgb(255 0 255) 1px 1px 3px;
  box-shadow: rgba(255, 93, 255, 1) -3px -3px 5px, rgba(0, 0, 0, 0.3) 6px 6px 3px; -->
            <!-- <div v-if="i < taotaiNum" class="total-inner" style="
            width: calc(100% - 3.5px);
            height: calc(100% - 3.5px);
            position: absolute;
            top: 2.5px;
            left: 2.5px;
            background: linear-gradient(rgb(255, 104, 255), rgb(149 13 196) 45% 65%, rgb(205 123 255));
            box-shadow:  #ff00ff 0 0 3px;
            "></div> -->
              <!-- <img v-if="i < taotaiNum" style="
              position: absolute;
              width: 158%;
              left: -29%;
              top: -111%;
              " src="../../assets/xuetiao1.png">
              <img v-else style="
              position: absolute;
              width: 158%;
              left: -29.5%;
      top: -91%;
              "  src="../../assets/xuetiao2.png"> -->
              <span style="z-index: 1;"
              :style="{'textShadow': i < taotaiNum ? '0px 0px 0px black' : '0px 0px 4px black'}">￥{{ parseInt(item.total.toFixed(0)) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="header" style="
    width: 100%;
    height: auto;
    display: block;" src="../../assets/bg-m-0614-bottom.jpg">
  </div>
</template>

<script>
import userList from './data-30.js'
import mockData from './mock.js'
import axios from '../axios-instance'
import moment from 'moment'

const limit = 7
export default {
  name: 'pagem-2-1',
  components: { },
  watch: {
  },
  data () {
    return {
      userList,
      data: [
        // {
        //   id: 1,
        //   nickname: '张三',
        //   account: 'zhangsan',
        //   total: 0,
        //   color: '#ff40f8',
        //   img: require('../../assets/logo.png')
        // }
      ],
      maxNum: 10000,
      topPosition: limit,
      interval: undefined,
      limit: limit,
      animating: false,
      touxiang: require('../../assets/touxiang.png'),
      taotaiNum: 1
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
    }, 20000)
    // this.getAllUserInfo().then(() => {
    this.getAllData(true)
    // this.getTestData()
    // })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    getAllUserInfo () {
      return axios({
        url: `https://www.yunlvltd.com/app-api/vote/cyber-star/getAll`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          // console.log('所有主播数据：', res.data)
          if (res.status === 200 && res.data && res.data.data && res.data.data.length) {
            this.userList = res.data.data.map((item) => {
              item.nickname += '·716'
              return item
            })
          }
        })
    },
    getTestData () {
      const data = mockData
      this.loaded(data, true)
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime0614m')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0614m') || '{}'), isFirst)
        return false
      }
      this.getData().then((res) => {
        // console.log('日志数据：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime0614m', moment().valueOf())
          window.localStorage.setItem('cacheData0614m', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData0614m') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0614m') || '{}'), isFirst)
      })
    },
    loaded (data, isFirst) {
      let res1 = this.userList.filter(item => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        // item.color = '#ff45fe'
        return item
      })
      res1 = res1.sort((a, b) => b.total - a.total).slice(0, 2)
      
      this.topPosition = this.limit
      
      // console.log(res)
      if (isFirst) {
        this.data = res1.map((item, i) => ({...item, total: 0}))
      }
      this.dealData(this.data, res1, isFirst)
    },
    getData () {
      return axios({
        url: `https://yudao-api-cache2.yunlvltd.com/app-api/vote/cyber-star/dp`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.data = this.data.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        this.maxNum = this.data[0].total || this.maxNum
        if (i >= 40) {
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    getOnce (n, o) {
      // 分多少次处理
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page260618/pagem-2-1.vue